import { SetNoneIcon } from './SetNoneIcon';

/**
 * author: Simran
 * id 9674B809-B544-45E8-BBD8-4E8D9E1A966E
 * name set-none
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-none.svg
 * tags
 * - Database 
 */
export const VennDiagramIcon = SetNoneIcon;
export default VennDiagramIcon